import React, { useState } from 'react';
import { RequirementsProps } from '../../../tools/context';
import { useTranslation } from '../../../tools/i18n';
import ButtonV2 from '../../ButtonV2';
import { Picto } from '../../Picto';
import EditJourney from '../EditJourney';
import ShareModal from '../Modal/ShareModal';
import NightDayHeaderDay from '../NightDayHeaderDay';
import PrintPDFButton from '../PDF/PrintButton';
import PriceBox from '../TravelDaysNight/PriceBox';
import { useTravelPlannerResultsContext } from '../TravelPlanerResultsContext';

const priceFeatureEnable = true;

interface NightDayHeaderProps {
  dayIndex: number;
  requirements: RequirementsProps;
}

const NightDayHeader: React.FC<NightDayHeaderProps> = ({ dayIndex, requirements }) => {
  const { t } = useTranslation();
  const { config, nightInfoVisible } = useTravelPlannerResultsContext();

  const [showShare, setShowShare] = useState(false);

  const tryToShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Share my trip',
          url: `${window.location.protocol}//${window.location.host}${window.location.pathname}`,
        });
      } catch (err) {
        console.error('Share failed:', err.message);
      }
      return;
    }
    setShowShare(true);
  };

  return (
    <div className="NightDayHeader" id="dayPoints">
      <div className="NightDayHeaderTop">
        {config.showAIMention ? (
          <div className="NightDayAiMention">
            <Picto iconKey="ai-mention" />
            <span>{t('travelPlaner.Travel.beta.content')}</span>
          </div>
        ) : undefined}
        <div className="NightDayHeaderButtons">
          {nightInfoVisible ? null : (
            <EditJourney picto="settings" withLabel requirement={requirements} />
          )}
          <ButtonV2
            variant="clear"
            leftIcon="share"
            text={t('travelPlaner.Travel.share')}
            onClick={tryToShare}
            className="ShareButton"
            trackingKey="openShare_click"
          />
          {config.showPrintInHeader ? <PrintPDFButton withLabel /> : null}
        </div>
        {config?.isPriceBoxShown && priceFeatureEnable ? (
          <PriceBox requirements={requirements} />
        ) : null}
      </div>
      {!config?.resultsInOneTab ? <NightDayHeaderDay dayIndex={dayIndex} /> : null}

      <ShareModal open={showShare} onClose={() => setShowShare(false)} />
    </div>
  );
};

export default NightDayHeader;
